import React, {useEffect, useState} from 'react';
//Components
import {ActivityIndicator, Animated, Clipboard, Image, Keyboard, TouchableOpacity, View} from 'react-native'
import {
    CustomButton,
    Header,
    Hr,
    IndicatorViewPager,
    InputDialog,
    InputField,
    Label,
    PagerTabIndicator,
    Ripple
} from "components/src/components";
//Utils
import styles from './styles';

import {
    Color,
    CommonStyle,
    Constants,
    decryptId,
    Icon,
    IS_WEB,
    Strings,
    ThemeUtils,
    validation
} from "components/src/utils";
import {connect} from "react-redux";
import {useMutation, useQuery} from "@apollo/react-hooks";
import {OFFICE_SERVICE_DETAILS} from "../../../../../../api/query";
import {
    DELETE_OFFICE_SERVICE_MEDIA,
    OFFICE_TEMPLATE_PHOTO_360_ATTACH_LINK,
    SAVE_OFFICE_TEMPLATE_SERVICE
} from "../../../../../../api/mutation";

const scrollY = new Animated.Value(0);

function OfficePhoto(props) {

    const {history, navigation} = props;

    const serviceFromPage = IS_WEB ? history.location?.state?.service ?? null : navigation.getParam('service', null);
    if (!serviceFromPage) {
        // IS_WEB ? history.replace(Routes.OfficePhotoStyling) : navigation.goBack();
    }
    const [service, setService] = useState(serviceFromPage?.office_template ?? {});

    const [headLines, setHeadLines] = useState("");
    const [errHeadline, setErrHeadLines] = useState(null);

    const [introText, setIntroText] = useState("");
    const [errIntroText, setErrIntro] = useState(null);

    const [selectionEnable, setSelectionEnable] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);

    const [link, setLink] = useState('');
    const [errLink, setErrLink] = useState(null);


    const [servicePrice, setServicePrice] = useState([]);
    const [errServicePrice, setErrServicePrice] = useState({});

    const [uploadImagesVisible, setUploadVisible] = useState(false);

    const [saveServiceDetails, saveDetailsMutation] = useMutation(SAVE_OFFICE_TEMPLATE_SERVICE);

    const [attachLink, attachLinkMutation] = useMutation(OFFICE_TEMPLATE_PHOTO_360_ATTACH_LINK, {
        refetchQueries: [{
            query: OFFICE_SERVICE_DETAILS,
            variables: {
                id: serviceFromPage?.office_template?.id ?? (IS_WEB ? decryptId(props.match.params?.id) : null)
            }
        }]
    });

    const [deleteImages, deleteImagesMutation] = useMutation(DELETE_OFFICE_SERVICE_MEDIA, {
        refetchQueries: [{
            query: OFFICE_SERVICE_DETAILS,
            variables: {
                id: serviceFromPage?.office_template?.id ?? (IS_WEB ? decryptId(props.match.params?.id) : null)
            }
        }]
    });

    const {loading, data, error} = useQuery(OFFICE_SERVICE_DETAILS, {
        fetchPolicy: 'network-only',
        variables: {
            id: serviceFromPage?.office_template?.id ?? (IS_WEB ? decryptId(props.match.params?.id) : null)
        }
    });

    useEffect(() => {
        setSelectionEnable(!!selectedImages.length)
    }, [selectedImages]);

    useEffect(() => {
        if (data?.office_template_details) {
            setService(data?.office_template_details);
            setHeadLines(data?.office_template_details?.headline);
            setIntroText(data?.office_template_details?.description);
            let price = data?.office_template_details?.office_services?.map(item => ({
                id: item.id,
                is_free: item.is_free,
                price: parseInt(item.price),
                free_text: item?.free_text ?? ""
            }));
            setServicePrice(price)
        }
    }, [data]);

    useEffect(() => {
        setErrLink(null)
    }, [link])

    const validateLink = () => {
        let error = validation('link', link)
        if (error) {
            setErrLink(error)
        } else {
            setErrLink(null)

            attachLink({
                variables: {
                    url: link,
                    templateId: service?.id
                }
            }).then(() => {
                setLink("")
            }).catch(() => {

            })

        }
    };

    const validate = () => {
        if (!IS_WEB) {
            Keyboard.dismiss()
        }
        let errHead = validation('headline', headLines);
        let errIntro = validation('intro', introText);
        let errPrice = {};
        let isError = false;
        servicePrice.map(item => {
            errPrice[item.id] = validation('servicePrice', item.price);
            if (errPrice[item.id]) {
                isError = true
            }
        });
        if (!errHead && !isError && !errIntro) {
            saveServiceDetails({
                variables: {
                    input: {
                        office_template_id: service?.id,
                        headline: headLines,
                        intro_text: introText,
                        /*    video:
                        iframeLink: String*/
                        servicesPrice: servicePrice.map(item => ({
                            ...item,
                            is_free: item.is_free ? 1 : 0,
                            price: parseInt(item.price)
                        }))
                    }
                }
            }).then((data) => {
                IS_WEB ? history.goBack() : navigation.goBack()
            }).catch(() => {

            })
        } else {
            setErrHeadLines(errHead);
            setErrIntro(errIntro);
            setErrServicePrice(errPrice)
        }
    };

    const handleChangeText = (text, id) => {
        let updatedService = servicePrice.slice();
        updatedService[id].price = text;
        setServicePrice(updatedService)
    };

    const addOrRemoveImage = (id) => {
        let updatedImages = selectedImages.slice();
        if (updatedImages.includes(id)) {
            updatedImages.splice(updatedImages.indexOf(id), 1)
        } else {
            updatedImages.push(id)
        }
        setSelectedImages(updatedImages)
    };

    const _renderTabIndicator = () => {

        return <PagerTabIndicator scrollEnabled={!ThemeUtils.isTablet()}
                                  tabs={[
                                      {
                                          text: `${serviceFromPage?.name} ${Strings.details}`
                                      }, {
                                          text: Strings.imageGallery
                                      }]}
        />;
    };

    const renderInput = (item, index) => {
        return (
            <View key={index.toString()}>
                <Label font_medium>
                    {item?.name}
                </Label>
                <Label small mt={ThemeUtils.relativeRealHeight(2)}>
                    {item?.description}
                </Label>
                <InputField mt={20}
                            style={CommonStyle.flex}
                            error={errServicePrice[item.id]}
                            onFocus={() => setErrServicePrice({...errServicePrice, [item.id]: null})}
                            labelProps={{
                                small: true,
                                font_medium: true
                            }}
                            type={'text'}
                            value={item?.is_free ? servicePrice[index]?.free_text : servicePrice[index]?.price}
                            onChange={(text) => handleChangeText(text, index)}>

                    {item.is_free ? null : (<View style={CommonStyle.inputExtra}>
                        <Label font_medium>
                            {'Kr.'}
                        </Label>
                    </View>)}
                </InputField>
            </View>
        )
    };

    const renderPhotoDetails = () => {
        return (
            <>
                <Label font_medium>
                    {Strings.headLine}
                </Label>
                <InputField disabled
                            mt={10}
                            align={'center'}
                            type={'text'}
                            error={errHeadline}
                            onFocus={() => setErrHeadLines(null)}
                            value={headLines}
                            onChange={setHeadLines}
                />
                <Label font_medium>
                    {Strings.introText}
                </Label>
                <InputField
                    error={errIntroText}
                    onFocus={() => setErrIntro(null)}
                    mt={10}
                    align={'center'}
                    type={'text'}
                    textArea
                    value={introText}
                    onChange={setIntroText}
                />


                {service?.office_services?.length ? (
                    <>
                        <Hr/>
                        <Label mt={ThemeUtils.relativeRealHeight(2)}
                               mb={ThemeUtils.relativeRealHeight(2)}
                               font_medium
                               large>
                            {`${Strings.services}:`}
                        </Label>
                        {service?.office_services?.map(renderInput)}
                    </>
                ) : null}


            </>
        );
    };

    const renderUploadImageDialog = () => {
        return (
            <InputDialog title={Strings.uploadLink}
                         onPositivePress={(text) => {

                             setUploadVisible(false)
                         }}
                         onNegativePress={() => setUploadVisible(false)}
                         visible={uploadImagesVisible}/>
        )
    };

    const renderPhotoGallery = () => {
        return (
            <>

                <Label small font_medium mt={10} mb={15}>
                    {Strings.attachViewLink}
                </Label>
                <View style={styles.inptCont}>
                    <View style={CommonStyle.flex}>
                        <InputField align={'center'}
                                    mr={ThemeUtils.COMMON_HORIZONTAL_MARGIN}
                                    type={'text'}
                                    error={errLink}
                                    onFocus={props.onFocus}
                                    placeholder={props.placeholder}
                                    value={link}
                                    onChange={setLink}

                        />
                    </View>

                    <Ripple style={styles.IconsView}
                            rippleContainerBorderRadius={4}
                            onPress={() => Clipboard.setString(link)}>
                        <Icon name={'copy'}
                              size={ThemeUtils.fontXLarge}
                              color={Color.PRIMARY}/>
                    </Ripple>
                </View>
                <CustomButton loading={attachLinkMutation.loading}
                              title={Strings.attachViewLink}
                              onPress={() => validateLink()}
                />

                {/*<Ripple style={[styles.SubViewIcon, {backgroundColor: Color.GRAY}]}
                        onPress={() => setUploadVisible(true)}>
                    {attachLinkMutation.loading ? (
                        <ActivityIndicator color={Color.PRIMARY}/>
                    ) : (<Icon name={'add'}
                               size={ThemeUtils.responsiveScale(60)}
                               color={Color.PRIMARY_LIGHT}/>)}

                </Ripple>*/}

                <Hr lineStyle={{marginTop: 20}}/>
                {selectionEnable ? (
                    <View style={styles.propertySelectionCont}>

                        <Icon name={'tickmark'}
                              size={ThemeUtils.fontNormal}
                              color={Color.PRIMARY}/>
                        <Label small
                               font_medium
                               ml={15}
                               style={CommonStyle.flex}>
                            {`${selectedImages.length} ${Strings.photoselected}`}
                        </Label>
                        {deleteImagesMutation.loading ? (
                            <ActivityIndicator color={Color.PRIMARY}/>
                        ) : (
                            <TouchableOpacity activeOpacity={0.6}
                                              onPress={() => {
                                                  deleteImages({
                                                      variables: {
                                                          ids: selectedImages,
                                                          templateId: service?.id
                                                      }
                                                  }).then(() => {
                                                      setSelectedImages([])
                                                  }).catch(() => {

                                                  })

                                              }}>
                                <Icon name={'delete'}
                                      size={ThemeUtils.fontNormal}
                                      color={Color.RED}/>
                            </TouchableOpacity>)}
                        <TouchableOpacity onPress={() => {
                            setSelectedImages([])
                        }} activeOpacity={0.6} style={{marginLeft: 20}}>
                            <Icon name={'close'}
                                  size={ThemeUtils.fontNormal}/>
                        </TouchableOpacity>
                    </View>
                ) : (<Label small
                            font_medium
                            mt={15}
                            mb={5}>
                    {Strings.Photos}
                </Label>)}
                {renderImageGrid(service?.office_service_media ?? [])}
            </>
        );
    };

    const renderImageGrid = (data, isDeletable) => {
        return <View style={styles.ImageGridView}>
            {data.map(item => {
                return (
                    <TouchableOpacity
                        key={item.id}
                        onLongPress={() => selectionEnable ? null : addOrRemoveImage(item.id)}
                        onPress={() => selectionEnable ? addOrRemoveImage(item.id) : null}
                        activeOpacity={0.7}>

                        {selectionEnable && selectedImages.includes(item.id) ? (<View style={[styles.selectedImage]}>
                            <Icon name={'tickmark'}
                                  size={ThemeUtils.fontNormal}
                                  color={Color.TERNARY_TEXT_COLOR}/>
                        </View>) : null}

                        <Image source={{uri: `${Constants.APIConfig.STORAGE_URL}${item?.media_url}`}}
                               style={styles.GridImage}/>
                    </TouchableOpacity>

                )
            })}
        </View>
    };
    return (
        <View style={styles.cont}>
            <Header tintColor={Color.PRIMARY}
                    style={CommonStyle.blankHeader}
                    navigation={IS_WEB ? history : navigation}/>

            <View>
                <View style={styles.contentCont}>
                    <View style={styles.titleCont}>
                        <Label xlarge
                               font_medium
                               mt={5}
                               ml={10}>
                            {serviceFromPage?.name}
                        </Label>
                    </View>
                </View>

            </View>
            <IndicatorViewPager keyboardShouldPersistTaps={'always'}
                                indicator={_renderTabIndicator()}
                                style={{flex: 1, backgroundColor: 'white'}}>
                <View>
                    {loading && !data ? (
                        <ActivityIndicator color={Color.PRIMARY}
                                           style={CommonStyle.loader}/>
                    ) : (
                        <>
                            <Animated.ScrollView scrollEventThrottle={1}
                                                 keyboardShouldPersistTaps={'always'}

                                                 contentContainerStyle={styles.flexGrow}
                                                 onScroll={Animated.event(
                                                     [{nativeEvent: {contentOffset: {y: scrollY}}}],
                                                     {useNativeDriver: true})}>
                                <View>
                                    <View style={styles.orderCont}>
                                        {renderPhotoDetails()}
                                    </View>
                                </View>
                            </Animated.ScrollView>
                            <View style={styles.bottomButtonContainer}>
                                <CustomButton loading={saveDetailsMutation.loading}

                                              style={{flex: 0.45}}
                                              title={Strings.save}
                                              onPress={validate}/>
                                <CustomButton
                                    style={{flex: 0.45}}
                                    title={Strings.cancel}
                                    bgColor={Color.WHITE}
                                    textColor={Color.PRIMARY_TEXT_COLOR}
                                    borderColor={Color.PRIMARY}
                                    borderWidth={1}
                                    onPress={() => {
                                        if (!IS_WEB) {
                                            Keyboard.dismiss()
                                        }
                                        IS_WEB ? history.goBack() : navigation.goBack()
                                    }}/>
                            </View>

                        </>
                    )}

                </View>
                <View>
                    <Animated.ScrollView scrollEventThrottle={1}
                                         keyboardShouldPersistTaps={'always'}
                                         contentContainerStyle={styles.flexGrow}
                                         onScroll={Animated.event(
                                             [{nativeEvent: {contentOffset: {y: scrollY}}}],
                                             {useNativeDriver: true})}>
                        <View>
                            <View style={styles.orderCont}>
                                {renderPhotoGallery()}
                            </View>
                        </View>
                    </Animated.ScrollView>
                </View>
            </IndicatorViewPager>

        </View>
    )
}

const mapStateToProps = (state) => {
    return {}
};
export default connect(mapStateToProps)(OfficePhoto);
